import React, { useState } from "react";
/** @jsxImportSource @emotion/react */
import { Button } from "antd";
import tw, { styled, css } from "twin.macro";
import MainLayout from "../../components/MainLayout/MainLayout";
import { hideScrollbar, LandingTitle } from "../../lib/styles/styleLibrary";
// import { useMediaQuery } from "react-responsive";
import {
	AccountSettings,
	GeneralSettings,
	PermissionSetting,
} from "../../components";

const Wrapper = styled.div`
	${tw`p-4 md:(pl-12 pr-12 pt-10) h-full pb-0 relative`}
`;

export const active = (props) => css`
	${tw`font-bold uppercase shadow rounded-2xl min-w-min text-appTextDark inline-flex gap-2 items-center justify-center py-4 hover:(text-appTextDark bg-gray-100 border-none) active:(text-appTextDark  bg-gray-100 border-none) focus:(text-appTextDark  bg-gray-200 border-none)`}
	font-family: Poppins;
	background-color: rgba(151, 151, 189, 0.2);
	line-height: 12px;
	letter-spacing: 0.5px;
	font-size: 0.875rem;
	@media (max-width: 1217px) {
		font-size: 0.65rem;
	}
`;
export const inactive = (props) => css`
	${tw`font-medium uppercase shadow-sm rounded-2xl min-w-min text-appTextFaded inline-flex gap-2 items-center justify-center py-4 hover:(text-appTextDark bg-gray-100 border-none) active:(text-appTextDark  bg-gray-100 border-none) focus:(border-none  bg-gray-200)`}
	font-family: Poppins;
	background-color: rgba(166, 166, 175, 0.082);
	line-height: 12px;
	letter-spacing: 0.5px;
	font-size: 0.875rem;
	@media (max-width: 1217px) {
		font-size: 0.65rem;
	}
`;

const MySettings = (props) => {
	// const isMobile = useMediaQuery({ maxWidth: 767 });
	const [flow, setFlow] = useState("general");
	const [clicked, setClicked] = useState(false);

	const togClicked = () => {
		setClicked(!clicked);
	};

	return (
		<MainLayout tw="relative">
			<Wrapper>
				<div tw="flex flex-row items-center justify-between flex-nowrap">
					<LandingTitle tw="text-base md:text-2xl font-bold leading-8 m-0! whitespace-pre">
						My Settings
					</LandingTitle>

					{/* <button
						onClick={() => togClicked()}
						tw="bg-appLightPink text-appPink rounded-2xl font-semibold px-3 py-1 border-none hover:(shadow-md text-appPinkSaturated font-bold cursor-pointer)">
						Save
					</button> */}
				</div>

				<div
					tw="mt-6 flex flex-row flex-nowrap items-center gap-2 overflow-x-scroll"
					css={hideScrollbar}>
					<Button
						onClick={() => setFlow("general")}
						css={flow === "general" ? active : inactive}>
						<span>General</span>
					</Button>
					<Button
						onClick={() => setFlow("account")}
						css={flow === "account" ? active : inactive}>
						<span>Account</span>
					</Button>
					<Button
						onClick={() => setFlow("permission")}
						css={flow === "permission" ? active : inactive}>
						Permission{" "}
					</Button>
				</div>

				<div tw="mt-4 mb-4! w-full h-full">
					{flow === "general" && <GeneralSettings />}
					{flow === "account" && (
						<AccountSettings
							togClicked={togClicked}
							clicked={clicked}
						/>
					)}
					{flow === "permission" && (
						<PermissionSetting
							togClicked={togClicked}
							clicked={clicked}
						/>
					)}
				</div>
			</Wrapper>
		</MainLayout>
	);
};

export default MySettings;
